export default __webpack_public_path__ + "static/media/dashboard_main_img.45bf13a1.png";